import { Box, Grid, VStack, HStack, Card } from '@chakra-ui/react';
import { motion } from 'framer-motion';

export const MotionBox = motion(Box);
export const MotionGrid = motion(Grid);
export const MotionVStack = motion(VStack);
export const MotionHStack = motion(HStack);
export const MotionCard = motion(Card);

export const variants = {
  container: {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.06, delayChildren: 0.04 },
    },
  },
  item: {
    hidden: { opacity: 0, y: 12 },
    show: { opacity: 1, y: 0, transition: { duration: 0.25, ease: 'easeOut' } },
  },
};

